import { HotelContentService } from './app/hotel-content/hotel-content.service';
import { PalsService } from './app/pals/pals.service';
import { HoldReservationService } from './app/hold-reservation/hold-reservation.service';
import { CommitReservationService } from './app/commit-reservation/commit-reservation.service';
import { BasicAvailService } from './app/basic-avail/basic-avail.service';
import { GlobalsService } from './app/globals/globals.service';
import { ProductServicesService } from './app/product-services/product-services.service';
import { SpecialCodesService } from './app/special-codes/special-codes.service';
import { RetrieveReservationService } from './app/retrieve-reservation/retrieve-reservation.service';
import { ModifyHoldReservationService } from './app/modify-hold-reservation/modify-hold-reservation.service';
import { ModifyCommitReservationService } from './app/modify-commit-reservation/modify-commit-reservation.service';
import { CancelReservationService } from './app/cancel-reservation/cancel-reservation.service';
import { BraintreeConfigurationService } from './app/braintree/braintree-configurations.service';
import { ExtendedHoldReservationService } from './app/extended-hold-reservation/extended-hold-reservation.service';
import { LoyaltyService } from './app/loyalty/loyalty.service';
import { VoucherService } from './app/voucher/voucher.service';
import { AbandonmentService } from './app/abandonment/abandonment.service';
import { PaymentInitService } from './app/payment-init/payment-init.service';
import { HotelMediaService } from './app/hotel-media/hotel-media.service';
import { AmadeusPaymentConfigurationService } from './app/amadeus-payment/amadeus-payment-configuration.service';
import { AmadeusTokenService } from './app/amadeus-token/amadeus-token.service';
import { MerchandiseService } from './app/merchandise/merchandise.service';
import { AlternatePropertiesService } from './app/alternate-properties/alternate-properties.service';
import { MetaCollectionService } from './app/meta-collection/meta-collection.service';
import { UpSellReservationService } from './app/enhance-upsell-reservation/enhance-upsell-reservation.service';
import { CybersourcePaymentService } from './app/cybersource-payment/cybersource-payment.service';

export default {
    HotelContentService,
    PalsService,
    HoldReservationService,
    CommitReservationService,
    BasicAvailService,
    GlobalsService,
    ProductServicesService,
    SpecialCodesService,
    RetrieveReservationService,
    ModifyHoldReservationService,
    ModifyCommitReservationService,
    CancelReservationService,
    BraintreeConfigurationService,
    ExtendedHoldReservationService,
    LoyaltyService,
    VoucherService,
    AbandonmentService,
    PaymentInitService,
    HotelMediaService,
    AmadeusPaymentConfigurationService,
    AmadeusTokenService,
    MerchandiseService,
    AlternatePropertiesService,
    MetaCollectionService,
    UpSellReservationService,
    CybersourcePaymentService
};
const ibeServices = {
    HotelContentService: HotelContentService,
    PalsService: PalsService,
    HoldReservationService: HoldReservationService,
    CommitReservationService: CommitReservationService,
    BasicAvailService: BasicAvailService,
    GlobalsService: GlobalsService,
    ProductServicesService: ProductServicesService,
    SpecialCodesService: SpecialCodesService,
    RetrieveReservationService: RetrieveReservationService,
    ModifyHoldReservationService: ModifyHoldReservationService,
    ModifyCommitReservationService: ModifyCommitReservationService,
    CancelReservationService: CancelReservationService,
    BraintreeConfigurationService: BraintreeConfigurationService,
    ExtendedHoldReservationService: ExtendedHoldReservationService,
    LoyaltyService: LoyaltyService,
    VoucherService: VoucherService,
    AbandonmentService: AbandonmentService,
    PaymentInitService: PaymentInitService,
    HotelMediaService: HotelMediaService,
    AmadeusPaymentConfigurationService: AmadeusPaymentConfigurationService,
    AmadeusTokenService: AmadeusTokenService,
    MerchandiseService: MerchandiseService,
    AlternatePropertiesService: AlternatePropertiesService,
    MetaCollectionService: MetaCollectionService,
    UpSellReservationService: UpSellReservationService,
    CybersourcePaymentService: CybersourcePaymentService
};
Object.freeze(ibeServices);
window['AmadeusHosResIbeServices'] = ibeServices;
